'use client';

import { Link } from 'react-router-dom';
import { CurrencyDollarIcon } from '@heroicons/react/24/outline';
import { apiConfig } from '@/config/api';

export default function PublicNavigation() {
  return (
    <nav className="bg-white shadow-sm relative z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center space-x-2">
              <img className="h-8 w-auto" src="/logo.svg" alt="Content Growth" />
              <span className="font-semibold text-lg text-gray-800">Content Growth</span>
            </Link>
          </div>

          {/* Right Side Navigation */}
          <div className="flex items-center space-x-6">
            <a
              href={`${apiConfig.wwwUrl}/pricing`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-gray-900 hover:text-gray-700 flex items-center"
            >
              Pricing
            </a>
            <a
              href={`${apiConfig.wwwUrl}/signin/`}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
            >
              Sign In
            </a>
            <a
              href={`${apiConfig.wwwUrl}/signup/`}
              className="inline-flex items-center px-4 py-2 border border-blue-600 text-sm font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50"
            >
              Sign Up
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
